import { Avatar, Divider } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ReactComponent as UnfollowIcon } from "shared/assets/images/unfollow-icon.svg";

interface FollowersModalProps {
  artists: any[];
  onRemove: (id: string) => void;
}
const FollowersModal: React.FC<FollowersModalProps> = (props) => {
  const { artists, onRemove } = props;
  const history = useHistory();
  const { t } = useTranslation("radar");
  return (
    <div className="followers-modal">
      <h1>{t("pages.Home.followrs")}</h1>
      <Divider />
      <div className="followers-modal-artists">
        <ul>
          {artists.map((artist: any) => (
            <li key={artist.id}>
              <div>
                <Avatar style={{ marginRight: 6 }} src={artist.imageUrl} />
                <span>{artist.artistName}</span>
              </div>
              <div>
                <button
                  onClick={() =>
                    history.push("/artist-profile", {
                      artist: { artistIdStrm: artist.artistIdStrm },
                    })
                  }
                >
                  {t("pages.Home.seeProfile")}
                </button>
                <UnfollowIcon
                  className="unfollow"
                  onClick={() => onRemove(artist?.artistIdStrm)}
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FollowersModal;
